<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          GUIDELINE TEXT
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9 class="pl-1">
            {{ id ? type + ' Guideline Text' : 'Create New Guideline Text' }}
          </v-flex>
          <v-flex xs3 class="text-right" v-if="isDetail || isEdit">
            <v-icon @click="getDetail" title="refresh">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs12 class="pa-0">
                <v-flex xs12>
                  <ValidationProvider
                    name="Title"
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <label class="darkblue--text">Title</label>
                    <v-autocomplete
                      id="title"
                      single-line
                      outlined
                      placeholder="Title"
                      dense
                      v-model="items.menu_id"
                      :items="listMenu"
                      item-value="id"
                      item-text="name"
                      required
                      class=""
                      :error-messages="errors"
                      :success="valid"
                      :disabled="isDetail"
                    />
                  </ValidationProvider>
                  <ValidationProvider
                    name="Version"
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <label class="darkblue--text">Version</label>
                    <v-text-field
                      id="version"
                      single-line
                      outlined
                      placeholder="Version"
                      dense
                      v-model="items.version"
                      required
                      class=""
                      :error-messages="errors"
                      :success="valid"
                      :disabled="isDetail"
                    ></v-text-field>
                  </ValidationProvider>
                  <label class="darkblue--text">Description</label>
                  <div
                    class=" img-size"
                    v-html="items.description"
                    v-if="isDetail"
                  ></div>
                  <vue-editor
                    v-else
                    v-model="items.description"
                    class=""
                    :editor-toolbar="customToolbar"
                    useCustomImageHandler
                    @image-added="handleImageAdded"
                  ></vue-editor>
                  <!-- useCustomImageHandler
                    @image-added="handleImageAdded" -->
                </v-flex>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right pt-6 px-0">
              <v-spacer></v-spacer>
              <v-flex xs2 right>
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'cmsText' }"
                >
                  Back
                </v-btn>
              </v-flex>
              <v-flex xs2 right v-if="!isDetail" class="ml-4">
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  @click="save()"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';
import { VueEditor } from 'vue2-editor';
// import Quill from 'quill';
// import { ImageResize } from 'quill-image-resize-module';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog,
    VueEditor
  },
  props: ['id', 'type'],
  data() {
    return {
      listMenu: [],
      items: {
        menu_id: '',
        menu: '',
        version: '',
        description: ''
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      // customModulesForEditor: [{ alias: "imageResize", module: ImageResize }],
      customToolbar: [
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image'],
        [{ direction: 'rtl' }],
        ['clean']
      ],
      loading: true,
      progressDialogLoading: false,
      search: '',
      isDetail: false,
      isEdit: false,
      breadcrumbs: [
        {
          text: 'Content Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Guideline Text List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: this.id
            ? this.type + ' Guideline Text'
            : 'Create New Guideline Text',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  mounted() {
    this.getMenu();
    if (this.id) {
      if (this.type === 'Detail') {
        this.isDetail = true;
        this.isEdit = false;
        this.getDetail();
      } else if (this.type === 'Edit') {
        this.isEdit = true;
        this.isDetail = false;
        this.getDetail();
      }
    } else {
      setTimeout(() => {
        this.progressDialogLoading = false;
        this.loading = false;
      }, 800);
    }
  },
  computed: {
    nameMenu() {
      return this.listMenu
        .filter(item => item.id == this.items.menu_id)
        .map(mapitem => {
          return mapitem.name;
        });
    }
  },
  methods: {
    async getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      await this.$store
        .dispatch('texts/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    save() {
      const validated = this.$refs.obs.validate();
      if (validated) {
        this.saveConfirm();
      }
    },
    saveConfirm() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to save this guideline text?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel it!'
      }).then(result => {
        if (result.value) {
          this.saveGuideline();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your document data has been canceled to save',
            'error'
          );
        }
      });
    },
    saveGuideline() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.items.menu = this.nameMenu[0];
      console.log(this.items);
      if (this.id) {
        this.$store
          .dispatch('texts/update', { id: this.id, params: this.items })
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.$router.push({
                name: 'cmsText'
              });
            } else {
              Swal.fire('Failed!', data.response.data.status, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.status, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        this.$store
          .dispatch('texts/create', this.items)
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.$router.push({
                name: 'cmsText'
              });
            } else {
              Swal.fire('Failed!', data.response.data.status, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.status, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      if (file.size <= 1000000) {
        this.progressDialogLoading = true;

        var formImage = new FormData();
        formImage.append('images', file);

        this.$store
          .dispatch('texts/upload', formImage)
          .then(data => {
            this.progressDialogLoading = false;
            let url = data.data; // Get url from response
            let base = this.baseUrl + '/images/';
            for (var i = 0; i < url.length; i++) {
              Editor.insertEmbed(
                cursorLocation,
                'image',
                base + url[i].nameFile
              );
            }
            resetUploader();
          })
          .catch(err => {
            console.log(err);
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      } else {
        Swal.fire(
          'Failed!',
          'Your image is too large. Image size max is 1MB. Please resize your image or change the image to be uploaded.',
          'error'
        );
      }
    },
    async getMenu() {
      this.progressDialogLoading = true;
      this.loading = true;
      await this.$store
        .dispatch('texts/getMenu', { paginate: false })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.listMenu = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    }
  }
};
</script>
